import Form from './Form'
import FormItem from './FormItem'
import FormSwitch from './FormSwitch'

export default Object.assign(Form, { Item: FormItem, Switch: FormSwitch })
